import { createContext } from "react";
import { ApiTableState } from "../../../types/ApiTable/ApiTableState";
import { ApiTableColumn } from "../../../types/ApiTable/ApiTableColumn";
import { ApiTableSorting } from "../../../types/ApiTable/ApiTableSorting";
import { ApiTableFiltering } from "../../../types/ApiTable/ApiTableFiltering";
import { ApiTablePagination } from "../../../types/ApiTable/ApiTablePagination";

export interface TableContextType {
  state: ApiTableState;
  updateSort: (sorting: ApiTableSorting) => void;
  updateFilter: (filter: ApiTableFiltering) => void;
  updatePagination: (pagination: ApiTablePagination) => void;
  clearFilter: (field: string) => void;
  columns: ApiTableColumn[];
}

export const TableContext = createContext<TableContextType | null>(null);
